import React from "react";
import { Col, Row } from "react-bootstrap";
import { DiGit, DiGithubFull } from "react-icons/di";
import {
	SiVisualstudiocode,
	SiPostman,
	SiSlack,
	SiVercel,
	SiMacos,
	SiWindows,
	SiCpanel,
	SiLinux,
} from "react-icons/si";

function Toolstack() {
	return (
		<Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
			<Col xs={4} md={2} className="tech-icons">
				<SiLinux />
			</Col>
			<Col xs={4} md={2} className="tech-icons">
				<SiWindows />
			</Col>
			<Col xs={4} md={2} className="tech-icons">
				<SiMacos />
			</Col>
			<Col xs={4} md={2} className="tech-icons">
				<SiVisualstudiocode />
			</Col>
			<Col xs={4} md={2} className="tech-icons">
				<SiCpanel />
			</Col>
			<Col xs={4} md={2} className="tech-icons">
				<DiGithubFull />
			</Col>
			<Col xs={4} md={2} className="tech-icons">
				<DiGit />
			</Col>
			<Col xs={4} md={2} className="tech-icons">
				<SiPostman />
			</Col>
			<Col xs={4} md={2} className="tech-icons">
				<SiSlack />
			</Col>
			<Col xs={4} md={2} className="tech-icons">
				<SiVercel />
			</Col>
		</Row>
	);
}

export default Toolstack;
